import messages from "@smartmixin/i18n/dist/translations/uk.json";

export default messages;
